angular.module('leanlaw').directive('onoff', function () {
  return {
    restrict: 'A',
    link: function (scope, elem, attr) {
      angular.element(elem).onoff();
    }
  };
});